import cx from 'classnames';
import React from 'react';
export function Tip(_a) {
    var tip = _a.tip, children = _a.children, colorConfig = _a.colorConfig, prefixCls = _a.prefixCls;
    if (typeof tip !== 'string') {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement("span", { className: cx("".concat(prefixCls, "-tip"), "".concat(prefixCls, "-tip-color-").concat(colorConfig.type)), style: {
            color: colorConfig.color,
        } }, tip));
}
